<div class="col th-p notification-content-wrapper">
  <header class="top-box-shadow">
    <div class="columns is-gapless is-vcentered is-mobile">
      <figure class="has-text-centered">
        <i
          class="fa hideMobileView"
          [ngClass]="{
            'fa-angle-double-left': !this.userComponent.viewUserList,
            'fa-angle-double-right': this.userComponent.viewUserList
          }"
          (click)="showHideUserList()"
        ></i>
      </figure>
      <div class="is-pulled-left">
        @if (!userCreationViewCtrl.showTable) {
        <span class="is-size-6 has-text-weight-semibold">{{
          userCreationViewCtrl.showForm ? "User Creation" : "Bulk Users Upload"
        }}</span>
        } @if (userCreationViewCtrl.showTable) {
        <span class="is-size-6 has-text-weight-semibold"
          >Bulk Users upload -
          <span class="has-text-link">{{ bulkUserFileName }}</span>
          Processed</span
        >
        }
      </div>

      <div class="column has-text-right">
        @if (!userCreationViewCtrl.showTable && userCreationViewCtrl.showForm) {
        <div class="desk-view">
          <a class="desk-icon">
            @if (!userCreationViewCtrl.addUserBtn) {
            <button
              class="button is-small is-link is-outlined"
              (click)="excelFileUploadSectionHandler()"
            >
              + Bulk Users Upload
            </button>
            }
          </a>
          <a
            class="desk-icon mobileViewBtn"
            data-tooltip="Close User Create"
            [routerLink]="['/userandgroup/user']"
          >
            <i class="fa fa-times is-size-6" aria-hidden="true"></i>
          </a>
        </div>
        } @else {
        <!-- <a class="desk-icon">
            <button class="button is-small is-link is-outlined" (click)="createNewStudent()">+ Create New Student</button>
          </a> -->
        }
      </div>

      @if (userCreationViewCtrl.showTable) {
      <div class="column has-text-right">
        <div class="desk-view">
          <a class="desk-icon btnDeskIcon">
            @if (!userCreationViewCtrl.showForm) {
            <button
              class="button is-small is-link is-outlined"
              (click)="cancelUserList()"
            >
              Cancel
            </button>
            }
            <button
              class="button is-link is-small mar-0-5"
              [ngClass]="{ 'is-loading': userCreationViewCtrl.startUpload }"
              (click)="createBulkUser()"
              [disabled]="userCreationViewCtrl.startUpload"
            >
              Save User Data
            </button>
          </a>
        </div>
      </div>
      }
    </div>
  </header>

  <div class="contents is-marginless mobileViewuserandgroup">
    <div class="scroll-bar">
      <div class="column">
        <div class="columns is-clearfix is-gapless display-flex">
          <div
            class="column is-12"
            [ngClass]="{
              'is-two-thirds is-offset-one-quarter':
                userCreationViewCtrl.showForm
            }"
          >
            <!-- <div class="columns new-chat mar-top15"> -->
            <div class="column is-9">
              @if (userCreationViewCtrl.showForm) {
              <div class="columns new-chat is-9">
                <div class="column">
                  <div class="card">
                    <div class="card-content">
                      <div class="content form-style">
                        <form [formGroup]="newUserForm" novalidate>
                          <!-- <h3>New User</h3> -->
                          <h4>Manage User</h4>
                          <div class="columns">
                            <div class="column">
                              <div class="field">
                                <div class="control profile-img">
                                  @if (!preUploadedFile) {
                                  <div>
                                    <img
                                      [src]="
                                        '../../../assets/images/user-icon.png'
                                      "
                                    />
                                  </div>
                                  } @if (preUploadedFile &&
                                  preUploadedFile.file_path) {
                                  <div>
                                    <img
                                      [src]="
                                        preProfileUrl +
                                        preUploadedFile.file_path
                                      "
                                    />
                                  </div>
                                  }
                                  <span class="img-options">
                                    <div class="dropdown is-hoverable">
                                      <div class="dropdown-trigger">
                                        <i class="fa fa-camera"></i>
                                      </div>
                                      <div
                                        class="dropdown-menu"
                                        id="dropdown-menu4"
                                        role="menu"
                                      >
                                        <div class="dropdown-content">
                                          <a class="dropdown-item">
                                            <label class="file-label">
                                              <input
                                                class="file-input"
                                                name="profile"
                                                id="profile"
                                                type="file"
                                                (change)="onFileChange($event)"
                                                [disabled]="
                                                  selectedFileList.length > 0
                                                "
                                                #fileInput
                                              />
                                              <span class="file-label"
                                                >Add Picture</span
                                              >
                                            </label>
                                          </a>
                                          @if (preUploadedFile) {
                                          <a
                                            class="dropdown-item"
                                            (click)="removeSelectedFile()"
                                            >Remove Picture</a
                                          >
                                          }
                                        </div>
                                      </div>
                                    </div>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >First Name
                                  <span class="required">*</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    name="first_name"
                                    placeholder="First Name"
                                    formControlName="first_name"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.first_name"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Last Name
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder="Last Name"
                                    formControlName="last_name"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.last_name"
                                  ></form-validation>
                                  <!-- <p class="is-small has-text-danger is-size-7" *ngIf="lastname">Please enter characters only</p> -->
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Roll Number</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="roll_number"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Role
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <div class="select is-fullwidth">
                                    <select
                                      [(ngModel)]="defaultSelectRole"
                                      formControlName="user_role"
                                    >
                                      <option value>-- select --</option>
                                      @for (role of roleList; track role) {
                                      <option value="{{ role.role_id }}">
                                        {{ role.role_name }}
                                      </option>
                                      }
                                    </select>
                                    <form-validation
                                      [control]="newUserForm.controls.user_role"
                                    ></form-validation>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Contact Number
                                  <span class="required"> *</span>
                                </label>
                                <div class="control has-icons-left">
                                  <input
                                    type="text"
                                    class="input"
                                    name="phone"
                                    placeholder="Enter contact number"
                                    formControlName="phone_no"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.phone_no"
                                  ></form-validation>
                                </div>
                                <!-- <div class="control">
                                    <input class="input" type="text" placeholder="" formControlName="phone_no">
                                    <form-validation [control]="newUserForm.controls.phone_no"></form-validation>
                                  </div> -->
                              </div>
                            </div>
                            <!-- <div class="column is-4">
                              <div class="field">
                                <label class="label">Registration Number </label>
                                <div class="control">
                                  <input class="input" type="text" placeholder="" formControlName="reg_number" (keydown)="keyDownHandler($event)">
                                </div>
                              </div>
                            </div> -->
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label"
                                  >Email
                                  <span class="required"> *</span>
                                </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="Email"
                                    placeholder=""
                                    formControlName="email_id"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.email_id"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="column is-4">
                            <div class="field">
                              <label class="label">Password
                                <span class="required"> *</span>
                              </label>
                              <div class="control">
                                <input class="input" type="password" placeholder="" formControlName="password" (keydown)="keyDownHandler($event)">
                                <form-validation [control]="newUserForm.controls.password"></form-validation>
                              </div>
                            </div>
                          </div>
                          <div class="column is-4">
                            <div class="field">
                              <label class="label">Last four SSN</label>
                              <div class="control">
                                <input class="input" type="text" placeholder="" formControlName="aadhar_number" maxlength="12" (keydown)="keyDownHandler($event)">
                                <form-validation [control]="newUserForm.controls.aadhar_number"></form-validation>
                              </div>
                            </div>
                          </div>-->
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Address</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="user_address"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div formGroupName="user_residential"> -->
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">City</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="user_city"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                            <!-- <div class="column is-4">
                          <div class="field">
                            <label class="label">Tax Id</label>
                            <div class="control">
                              <input class="input" type="text" placeholder="" formControlName="pan_number" (keydown)="keyDownHandler($event)">
                              <form-validation [control]="newUserForm.controls.pan_number"></form-validation>
                            </div>
                          </div>
                        </div> -->
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">State</label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="user_state"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns">
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">Zip </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="user_zip"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.user_zip"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <div class="column is-4">
                              <div class="field">
                                <label class="label">User Id </label>
                                <div class="control">
                                  <input
                                    class="input"
                                    type="text"
                                    placeholder=""
                                    formControlName="emis_number"
                                    maxlength="10"
                                    (keydown)="keyDownHandler($event)"
                                  />
                                  <form-validation
                                    [control]="newUserForm.controls.emis_number"
                                  ></form-validation>
                                </div>
                              </div>
                            </div>
                            <!-- <div class="column is-4">
                        <div class="field">
                          <label class="label">Other ID's</label>
                          <div class="control">
                            <input type="text" class="input" placeholder="" formControlName="other_ids" (keydown)="keyDownHandler($event)">
                          </div>
                        </div>
                      </div> -->
                          </div>
                          <!-- </div> -->
                          <!-- <div class="columns">
                  <div class="column is-4">
                    <div class="field">
                      <div class="label">
                        <label class="label">Gender
                          <span class="required"> *</span>
                        </label>
                      </div>
                      <div class="field-body">
                        <div class="field is-narrow">
                          <div class="control">
                            <label class="radio" *ngFor="let item of genderArrayList; let i=index">
                              <input type="radio" name="gender" [value]="item.value" [checked]="item.value==defaultGender" formControlName="gender" [(ngModel)]="defaultGender">
                              {{item.name}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-4">
                    <div class="field">
                      <label class="label">Group/Classroom</label>
                      <div class="control select is-3">
                        <select class="select" formControlName="class_group" >
                          <option value="">--Select Group/Class--</option>
                          <option *ngFor="let item of classList" value="{{item.group_id}}">{{item.group_name}}</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div> -->
                          <div class="columns">
                            <div class="column is-12">
                              <div class="field">
                                <label class="label">Notes</label>
                                <div class="control">
                                  <textarea
                                    class="textarea"
                                    placeholder=""
                                    (keydown)="keyDownHandler($event)"
                                    formControlName="user_notes"
                                    rows="1"
                                  ></textarea>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="columns display-flex">
                            <!-- <div class="column is-4">
                  <button type="button" class="button is-link" [disabled]="!newUserForm.valid" (click)="addGroupSection()">Add Group</button>
                  <p class="display-ib mar-10-0" *ngIf="groupIdList.length > 0">{{groupIdList.length}} groups added</p>
                </div> -->
                            <div class="column is-12 has-text-right">
                              <button
                                type="button"
                                [routerLink]="['/userandgroup/user']"
                                class="button is-right is-small mar-0-10"
                                (click)="cancelRegister()"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                class="button is-link is-right is-small"
                                [disabled]="!newUserForm.valid"
                                (click)="addNewUser(newUserForm.value)"
                              >
                                Save
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              }
            </div>

            @if (userCreationViewCtrl.showFileChoosen) {
            <div class="columns">
              <div class="column user-bulk-cr">
                <div class="has-text-left top-align">
                  <div class="columns is-mobile is-centered">
                    @if (!excelFileList) {
                    <div class="column is-three-quarters">
                      <div class="card">
                        <div class="card-content">
                          <p class="mar-bot5">
                            This section helps you with “+ Bulk Users Upload,
                            Please note the following and proceed further.
                          </p>
                          <div class="right-align">
                            <ul class="">
                              <li>
                                When using Bulk upload, only normal user are
                                created i.e.,user-role ="user"
                              </li>
                              <li>
                                Please fill the data as mentioned in the sample
                                template file (
                                <i
                                  class="fa fa-download has-text-link"
                                  aria-hidden="true"
                                  (click)="getBulkUserTemplate()"
                                >
                                  click here</i
                                >
                                )
                              </li>
                              <li>All the fields in the files are mandatory</li>
                              <li>
                                Please recheck the uploaded file, if any error
                                occurs
                              </li>
                              <!-- <li></li> -->
                            </ul>
                          </div>
                          <div class="field has-text-centered">
                            <a
                              class="button is-small mar-0-5"
                              (click)="onCancelFileUploadSection()"
                              >Cancel</a
                            >
                            <div class="file is-link is-small display-ib">
                              <label class="file-label" style="margin: 0 auto">
                                <input
                                  class="file-input"
                                  type="file"
                                  name="resume"
                                  (change)="onExcelFileChoosen($event)"
                                  #excelFile
                                  accept=".xls"
                                />
                                <span class="file-cta">
                                  <button
                                    class="button is-link is-right is-small"
                                    (click)="excelFile.click()"
                                  >
                                    Choose a File
                                  </button>
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    } @if (excelFileList) {
                    <div class="column is-two-thirds">
                      <div class="card">
                        <div class="card-content">
                          <p class="mar-bot5 file-upload-nxt">
                            You have chosen the following file, to proceed
                            further please click on “Upload”
                          </p>
                          <!-- <p class="pad-5-10 has-text-link mar-bot5">{{excelFileList?.name}}</p> -->
                          <div class="has-text-centered">
                            <p class="has-text-link mar-bot5">
                              {{ excelFileList?.name }}
                            </p>
                          </div>
                          <div class="field has-text-centered is-small">
                            <a
                              class="button is-small mar-0-5"
                              (click)="onCancelFileUploadSection()"
                              >Cancel</a
                            >
                            <a
                              class="button is-small is-dark mar-0-5"
                              (click)="onClearExcelFileChoosen()"
                              >Clear</a
                            >
                            <button
                              class="button is-small is-link mar-0-5"
                              [ngClass]="{
                                'is-loading': excelFileOpt.showProgress
                              }"
                              (click)="onUploadFileProcess()"
                              [disabled]="excelFileOpt.showProgress"
                            >
                              Upload
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
            } @if (userCreationViewCtrl.showTable) {
            <div class="columns content-height-calc is-12 scroll-bar">
              <div class="column is-12">
                <article
                  class="message is-info"
                  style="margin-bottom: 1em !important"
                >
                  <div
                    class="message-body"
                    style="padding: 0.72em 1em !important"
                  >
                    <i class="fa fa-info-circle" aria-hidden="true"></i>
                    Uploaded file has following information, please review it
                    and click on 'Save User Data' to complete the upload
                  </div>
                </article>
                @if (excelUserList.length > 0) {
                <table class="table is-striped is-fullwidth bulkuplTableView">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Roll Number</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email</th>
                      <th>Gender</th>
                      <th>Phone</th>
                      <th>Group/Lessonroom</th>
                      <th>Action</th>
                      <!-- <th>Reg. Number</th>
                <th>Role </th>
                <th>Phone Number</th>
                <th>Aadhar Card Number</th>
                <th>Options</th>
                <th>Address</th>
                <th>City</th>
                <th>State</th>
                <th>Zip Postal</th>
                <th>Pan Number</th>
                <th>Other Id's</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    @for (user of excelUserList; track user; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ user.roll_number }}</td>
                      <td>{{ user.first_name }}</td>
                      <td>{{ user.last_name }}</td>
                      <td>{{ user.email_id }}</td>
                      <td>{{ user.gender }}</td>
                      <td>{{ user.phone_no }}</td>
                      <td>{{ user.group }}</td>
                      <!-- <td>{{user.registration_number}}</td>
                  <td>{{user.address}}</td>
                  <td>{{user.city}}</td>
                  <td>{{user.zip_postal}}</td>
                  <td>
                    <code class="html has-text-link">{{user.user_role}}</code>
                  </td>
                  <td>{{user.phone_number}}</td>
                  <td>{{user.aadhaar_number}}</td>
                  <td>{{user.pan_number}}</td>
                  <td>{{user.other_ids}}</td> -->
                      <td>
                        <i
                          class="fa fa-trash-o"
                          aria-hidden="true"
                          title="Remove user"
                          (click)="removeUserFromListHandler(user)"
                        ></i>
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }
              </div>
            </div>
            }

            <!-- <div class="columns up-btn-fix" *ngIf="userCreationViewCtrl.showTable">
  <div class="column is-6">
    <a class="button is-small is-outlined mar-0-5" (click)="cancelUserList()">Cancel</a>
  </div>
  <div class="column is-6 has-text-right">
    <button class="button is-link is-small mar-0-5"
      [ngClass]="{'is-loading' : userCreationViewCtrl.startUpload}"
      (click)="createBulkUser()"
    [disabled]="userCreationViewCtrl.startUpload">Create Users</button>
  </div>
</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Group list modal -->
@if (toggleModalSection) {
<div class="modal" [ngClass]="{ 'is-active': toggleModalSection }">
  <div class="modal-background"></div>
  <div class="modal-card">
    <div class="modal-card-head">
      <p class="modal-card-title">Select Groups</p>
      <!-- <button class="delete" aria-label="close" (click)="addGroupSection()"></button> -->
    </div>
    <section class="modal-card-body">
      <div class="content">
        <div class="columns">
          <div class="column">
            <div class="field">
              <div class="panel-block">
                <p class="control has-icons-left has-icons-right">
                  <input
                    class="input is-small"
                    type="text"
                    placeholder="search"
                    [(ngModel)]="searchText"
                    (keyup.enter)="groupSearchAndPagination(0)"
                  />
                  <span class="icon is-small is-left">
                    <i class="fa fa-search"></i>
                  </span>
                  <span class="icon is-small is-right">
                    <i class="fa fa-close"></i>
                  </span>
                </p>
              </div>
              <!-- <div class="panel scroll-bar panel-overflow" infinite-scroll [infiniteScrollDistance]="modalScrollDistance" [infiniteScrollThrottle]="modalScrollThrottle"
                [scrollWindow]="false" (scrolled)="onScrollDown()"> -->
              <div
                class="panel scroll-bar panel-overflow"
                appInfiniteScroll
                (reachedBottom)="onScrollDown()"
              >
                @for (group of groupList; track group) {
                <label
                  class="panel-block pos-relative"
                  [ngClass]="{
                    'active-bg': groupIdList.indexOf(group.group_id) > -1
                  }"
                  (click)="selectGroup(group.group_id)"
                >
                  <span class="image is-32x32 mar-0-10">
                    @if (!group.group_icon) {
                    <empty-uname
                      [userName]="group.group_name"
                      [detailHeadProfile]="true"
                    ></empty-uname>
                    } @if (group.group_icon) {
                    <img [src]="profileUrl + group.group_icon" />
                    }
                  </span>
                  {{ group.group_name }}
                  @if (groupIdList.indexOf(group.group_id) > -1) {
                  <span class="icon is-small icon-align is-pulled-right">
                    <i class="fa fa-check"></i>
                  </span>
                  }
                </label>
                }
                <pagination-loader
                  [showFetchLoader]="showPaginateLoader"
                ></pagination-loader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal-card-foot">
      <div class="column has-text-right">
        <button
          type="button"
          class="button is-right mar-0-10"
          (click)="clearGroupSection()"
        >
          Cancel
        </button>
        <button
          type="submit"
          class="button is-link is-right"
          [disabled]="groupIdList.length === 0"
          (click)="addGroupSection()"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
</div>
}
